import { useAuthAppStore } from "@/store/stores/authStore";

export class DevextremeCrudService {
  async getAllEntities({ client, route, queryStr }) {
    var response = await client.get({
      route: route,
      params: queryStr,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
        "Content-Type": "application/json",
      }
    });

    return response;
  }

  async putEntities({ client, route, data, successCallback, errorCallback }) {
    await client.put({
      // route: "/approval-matrix/update-entity",
      route: route,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      data: data,
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
  }

  async createEntities({ client, route, data, successCallback, errorCallback }) {
    await client.post({
      route: route,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      data: data,
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
  }

  async exportEntities({ client, route, filters }) {
    var response = await client.get({
      route: route,
      data: { Filters: filters },
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        "Content-Type": "application/json",
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
    });
    return response;
  }

  async deleteEntity({ client, route, params, successCallback, errorCallback }) {
    await client.delete({
        route: route,
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Authorization": `Bearer ${useAuthAppStore().token}`
        },
        params: params,
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
  }

  async deleteEntities({ client, route, data, successCallback, errorCallback }) {
    await client.deleteWithBody({
      route: route,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        "Authorization": `Bearer ${useAuthAppStore().token}`,
        "Content-Type": "application/json",
      },
      data: data,
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
  }
}
